<template>
  <TopCategories
    :top-title-color="mgnlProps.topTitleColor"
    :top-title="mgnlProps.topTitle"
    :slides="mgnlProps.slides"
    :data-ab-id="mgnlProps?.dataABId"
  />
</template>

<script lang="ts" setup>
import { TopBuilder, WrapperProps } from './Top.model';
import TopCategories from './Top.vue';
import magnoliaGetters from '~/composables/getters/magnoliaGetters';

const props = defineProps(WrapperProps);

const {
  topTitleColor,
} = toRefs(props);

const mgnlProps = {
  ...TopBuilder.build(props),
  topTitleColor: magnoliaGetters.getHexColor(topTitleColor?.value),
};

provide('imageLoadType', mgnlProps.imageLoadType);

magnoliaGetters.migratePageLinkToCtaLink(mgnlProps);
</script>
